<template>
  <div class="text-center">
    <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" offset-x>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" class="white--text" color="primary"><v-icon color="white">mdi-menu</v-icon></v-btn>
      </template>
      <v-card color="primary" class="cardContainer white--text" :max-width="maxWidth">
        <v-card-title class="cardContainer-header" @click="closeMenu">
          <div class="cardContainer-title"><span class="cardContainer-title-bold">Welcome</span> to Evntl</div>
          <div class="cardContainer-subtitle">This application is powered by our Critical Event Notification System</div>
          <div class="cardContainer-version">{{ generalGetVersionNumber }}</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-list class="listcontainer" color="primary">
          <v-list-tile class="clickable" @click="toEvntlcom">
            <v-list-tile-title>Evntl.com</v-list-tile-title>
            <v-list-tile-action> <v-icon>mdi-home</v-icon> </v-list-tile-action>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile class="clickable" @click="toContactUs">
            <v-list-tile-title>Contact Us</v-list-tile-title>
            <v-list-tile-action> <v-icon>mdi-email-variant</v-icon> </v-list-tile-action>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile class="clickable" @click="toDashboard">
            <v-list-tile-title v-if="generalGetMobileState">JHs' Map</v-list-tile-title>
            <v-list-tile-title v-else>John Hopkins' Map Dashboard</v-list-tile-title>
            <v-list-tile-action> <v-icon>mdi-link-variant</v-icon> </v-list-tile-action>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile class="clickable" @click="toDataTable">
            <v-list-tile-title>Data Table</v-list-tile-title>
            <v-list-tile-action> <v-icon>mdi-database</v-icon> </v-list-tile-action>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile class="clickable" v-if="!generalGetMobileState">
            <v-list-tile-title>Enable Bottom Bar</v-list-tile-title>
            <v-list-tile-action> <v-switch v-model="autoDisplay" color="primary"></v-switch> </v-list-tile-action>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile class="clickable">
            <v-list-tile-title>Enable Map View</v-list-tile-title>
            <v-list-tile-action> <v-switch v-model="enableComponents" color="primary"></v-switch> </v-list-tile-action>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile class="clickable">
            <v-list-tile-title>Enable Follow New Events</v-list-tile-title>
            <v-list-tile-action> <v-switch v-model="followEvents" color="primary"></v-switch> </v-list-tile-action>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile class="clickable" @click="toCountryZoom">
            <v-list-tile-title>Enable Country Zoom Level</v-list-tile-title>
            <v-list-tile-action> <v-icon>mdi-earth</v-icon> </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'MenuDropdown',
  data() {
    return {
      menu: false,
      enableComponents: false,
      autoDisplay: true,
      followEvents: false
    };
  },
  watch: {
    enableComponents(newValue) {
      this.$store.commit('generalUpdateEnableComponents', newValue);
      this.closeMenu();
    },
    autoDisplay(newValue) {
      this.$store.commit('generalUpdateAutoDisplay', newValue);
      this.closeMenu();
    },
    followEvents(newValue) {
      this.$store.dispatch('generalApplyFollowEvents', newValue);
      this.closeMenu();
    }
  },
  computed: {
    ...mapGetters({
      generalGetMobileState: 'generalGetMobileState',
      generalGetWidthState: 'generalGetWidthState',
      generalGetEnableComponents: 'generalGetEnableComponents',
      generalGetAutoDisplay: 'generalGetAutoDisplay',
      generalGetFollowEvents: 'generalGetFollowEvents',
      generalGetVersionNumber: 'generalGetVersionNumber'
    }),
    maxWidth() {
      if (this.generalGetMobileState) {
        return this.generalGetWidthState;
      } else {
        return 450;
      }
    }
  },
  methods: {
    toEvntlcom() {
      window.open('https://evntl.com/', '_blank');
    },
    toContactUs() {
      window.open('mailto:info@evntl.com', '_blank');
    },
    toDashboard() {
      if (this.generalGetMobileState) {
        window.open('http://www.arcgis.com/apps/opsdashboard/index.html#/85320e2ea5424dfaaa75ae62e5c06e61', '_blank');
      } else {
        window.open('https://www.arcgis.com/apps/opsdashboard/index.html#/bda7594740fd40299423467b48e9ecf6', '_blank');
      }
    },
    toDataTable() {
      this.$router.push('/datatable');
    },
    toCountryZoom() {
      this.$store.commit('generalUpdateCountryZoom', true);
      this.closeMenu();
    },
    closeMenu() {
      if (this.menu) {
        this.menu = false;
      }
    }
  }
};
</script>

<style scoped>
.cardContainer-header {
  display: block;
}
.cardContainer-title-bold {
  font-weight: bold;
  font-size: 1.4rem;
}
.cardContainer-title {
  font-size: 1.3rem;
}
.cardContainer-subtitle {
  font-size: 1rem;
}
.clickable {
  cursor: pointer;
}
.listcontainer {
  background: #eaeef7;
}
.cardContainer-version {
  margin-top: 1rem;
  font-size: 0.7rem;
}
</style>
